<template>
  <div
    class="password-container w-full px-4 py-4 bg-[var(--theme-pwa-bg)] flex flex-col justify-center items-center"
  >
    <div class="text-white/70 text-[14px] w-full mb-4 text-left">{{ title }}</div>
    <div class="input-box flex justify-between w-full px-2" @click="focusInput">
      <div
        v-for="(_, index) in 6"
        :key="index"
        :class="[
          'box w-[40px] h-[40px]   flex items-center justify-center rounded-[6px]',
          index == password.length && isFocused
            ? 'focused border-[2px] border-solid  border-[var(--theme-gray100)]'
            : '',
        ]"
      >
        <span
          v-if="index < password.length"
          class="dot bg-white w-[10px] h-[10px] rounded-full"
        ></span>
        <span
          v-if="index == password.length && isFocused"
          class="bg-white w-[1px] h-[12px] animate-blink"
        ></span>
      </div>
    </div>
    <van-field
      ref="hiddenInput"
      class="hidden-input absolute opacity-0 pointer-events-none h-0"
      v-model="password"
      maxlength="6"
      @input="handleInput"
      :inputmode="'numeric'"
      @focus="isFocused = true"
      @blur="isFocused = false"
    />
  </div>
</template>

<script setup lang="ts">
const hiddenInput = ref<HTMLInputElement | null>(null);
const password = ref("");
const isFocused = ref(false);
const focusInput = () => {
  hiddenInput.value?.focus();
};
const { title } = defineProps<{
  title: string;
}>();
const emit = defineEmits(["update:modelValue", "next"]);
const handleInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  input.value = input.value.replace(/[^0-9]/g, "");
  password.value = input.value.slice(0, 6);
  console.log(password.value);
  emit("update:modelValue", password.value);
};

defineExpose({
  focusInput,
});
</script>

<style scoped lang="scss">
.password-container {
  .box {
    background-color: var(--input-bg-color);
  }
  .confirm-button:disabled {
    background-color: var(--inner-table-bg-color100);
    cursor: not-allowed;
  }

  .animate-blink {
    animation: blink 1s infinite;
  }
  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
</style>
